export const appConfig = {
    appName: "Hrplus",
    baseUrl: "https://online.hrplus.uz",

    api: {
        contactUrl: "/api/advert-app/contact"
    },

    organization: {
        location_coords: [41.3240067, 69.2318321],
        contact_phone: "+998 94 002-09-12",
        contact_email: "raxmatoveldor37@gmail.com",
        contact_telegram_link: "https://t.me/Jack_20010912",
        contact_youtube_link: "#",
        contact_instagram_link: "#",
    },
};
